// qc
const QualityControl = () => import("Modules/manufacturing/quality_control/views/QualityControl");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "quality_control",
            name: "quality_control",
            component: QualityControl,
            meta: {
                requiresAuth: true,
                title: "lang.quality_control",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["qc_inspection.read"],
            },
        },
    ],
};
